import * as React from 'react';
import {Box, Cover, Template, Center, Stack, Heading} from '@pluto-tv/assemble';

export default (): JSX.Element => {
  return (
    <>
      <Box background='slate'>
        <Cover center={true}>
          <Template label='cover'>
            <Center textCenter={true}>
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  width: '37.5rem',
                  transform: 'translate(-50%, -50%)',
                  height: '10rem',
                }}
              >
                <Stack space='large'>
                  <Heading color='highlight' level='h2'>
                    Just one more step before you are granted access.
                  </Heading>
                  <Heading level='h3'>Reach out to a CMS administrator to request a role assignment.</Heading>
                </Stack>
              </div>
            </Center>
          </Template>
        </Cover>
      </Box>
    </>
  );
};
